export default "__VITE_ASSET__0i1GmZEm__"